import Tools from './../components/tools';

export default class Cse {
  constructor() {
    // Archive CSE
    this.displayForm();
  }

  displayForm() {
    const form = document.querySelector('section.content .offres-container .col.avis .avis-form .form');
    if (form) {
      const showFormBtn = document.querySelector('section.content .offres-container .col.avis .avis-form .lien');
      showFormBtn.addEventListener('click', () => {
        if (!form.classList.contains('open')) {
          Tools.zeroToAuto(form);
          const merciContainer = document.querySelector('section.content .offres-container .col.avis .avis-form .merci');
          if (merciContainer) {
            Tools.autoToZero(merciContainer);
          }
        }
        form.classList.add('open');
      });

      const hideFormBtn = document.querySelector('section.content .offres-container .col.avis .avis-form .form form .buttons span');
      hideFormBtn.addEventListener('click', () => {
        if (form.classList.contains('open')) {
          Tools.autoToZero(form);
        }
        form.classList.remove('open');
      });
    }
  }
}